import { GenericRepository } from './generic-repository';

export class LocalStorageRepository<T extends { id: number }> extends GenericRepository<T> {

  public constructor(private key: string, private defaultValue: T[] = []) {
    super();
    this.key = key;
    this.initLocalStorage();
    this.fetch();
  }

  public initLocalStorage(): void {
    const stored = localStorage.getItem(this.key);

    try {
      const parsed = stored ? JSON.parse(stored) : null;

      const isArray = Array.isArray(parsed);
      const hasSameLength = isArray && parsed.length === this.defaultValue.length;

      if (!isArray || !hasSameLength) {
        localStorage.setItem(this.key, JSON.stringify(this.defaultValue));
      }
    } catch (e) {
      console.error(e);
      localStorage.setItem(this.key, JSON.stringify(this.defaultValue));
    }
  }

  public fetch(): void {
    const dataStr = localStorage.getItem(this.key);
    if (dataStr) {
      try {
        const data: T[] = JSON.parse(dataStr);
        this.setData(data);
      } catch (error) {
        console.error(`Error parsing data for key ${this.key}:`, error);
        this.setData([]);
      }
    } else {
      this.setData([]);
    }
  }

  public save(item: T): void {
    const currentData = this.data();
    const newData = [...currentData, item];
    localStorage.setItem(this.key, JSON.stringify(newData));
    this.setData(newData);
  }

  public update(item: T): void {
    const currentData = this.data();
    const newData = currentData.map(el => el.id === item.id ? item : el);
    localStorage.setItem(this.key, JSON.stringify(newData));
    this.setData(newData);
  }

  public delete(id: number): void {
    const currentData = this.data();
    const newData = currentData.filter(el => el.id !== id);
    localStorage.setItem(this.key, JSON.stringify(newData));
    this.setData(newData);
  }
}
